import { baseApi } from '../baseApi';
import { Question } from './testApi';

export const questionBankApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getBankQuestions: builder.query<{ success: boolean; data: Question[]; total: number }, any>({
      query: (params) => ({
        url: '/api/question-bank',
        params,
      }),
      providesTags: ['Question'],
    }),
    createBankQuestion: builder.mutation<{ success: boolean; data: Question }, Partial<Question>>({
      query: (body) => ({
        url: '/api/question-bank',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Question', 'Dashboard'],
    }),
    updateBankQuestion: builder.mutation<{ success: boolean; data: Question }, { id: string; body: Partial<Question> }>({
      query: ({ id, body }) => ({
        url: `/api/question-bank/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['Question', 'Dashboard'],
    }),
    deleteBankQuestion: builder.mutation<{ success: boolean; message: string }, string>({
      query: (id) => ({
        url: `/api/question-bank/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Question', 'Dashboard'],
    }),
  }),
});

export const {
  useGetBankQuestionsQuery,
  useCreateBankQuestionMutation,
  useUpdateBankQuestionMutation,
  useDeleteBankQuestionMutation,
} = questionBankApi;
